import React from "react";
import classes from "./ViewCertificate.module.scss";
import ShotclassNewLogo from "../../../../../components/Common/SvgIcons/CommonIcons/ShotclassNewLogo";
import Logo from "../../../../../components/Logo/Logo";
import starImg from "../../../../../assets/images/organizeIcons/star.png";
import Shotclasses_General_Logo from "../../../../../assets/images/Common/Shotclasses_General_Logo.png";

const ViewCertificate = ({ title, selectedCertificate }) => {
  const { LogoImage } = JSON.parse(
    localStorage.getItem("themeData")
  ).CustomData;

  const logoDimesnion = {
    width: "150px",
    height: "60px",
    logoImage: LogoImage,
    altText: "Logo Text is missing",
  };

  return (
    <div className={classes.view_certificate}>
      <div className={classes.content}>
        <div className={classes.compnay_logo}>
          <Logo logoDimesnion={logoDimesnion} />
        </div>
        <div className={classes.heading}>
          <img src={starImg} alt="star" />
          <span>CERTIFICATE</span>
          <img src={starImg} alt="star" />
          <br />
        </div>
        <span className={classes.title}>{selectedCertificate?.Name}</span>
        <div className={classes.supporting_text}>
          <div className={classes.text1}>THIS IS TO CERTIFY THAT</div>
          <div>
            successfully completed the <br />
            course on
          </div>
        </div>
        <div>{title}</div>
        <div className={classes.shotclasses_logo}>
          {/* <ShotclassNewLogo /> */}
          <img src={Shotclasses_General_Logo} alt="Shotclasses Default Logo" style={{marginTop: "2rem"}}  />
        </div>
      </div>
      <div className={classes.signature}>
        <p>Date</p>
        <p>Signature</p>
      </div>
    </div>
  );
};

export default ViewCertificate;
